export default __webpack_public_path__ + "static/media/Cyber Policy.328361bd.jpg";